export default __webpack_public_path__ + "static/media/Vector5.02101337.svg";